import {Selector} from '@ngxs/store';
import {MyEventsState, MyEventsStateModel} from './my-events.state';
import {ActiveEventDetailOutputDto} from '@smatchy/sdk';

export class MyEventsSelector {
  @Selector([MyEventsState])
  static loading(state: MyEventsStateModel): boolean {
    return state.loading;
  }

  @Selector([MyEventsState])
  static countNextEvents(state: MyEventsStateModel): number {
    return state.nextEvents.length;
  }

  @Selector([MyEventsState])
  static countPastEvents(state: MyEventsStateModel): number {
    return state.pastEvents.length;
  }

  @Selector([MyEventsState])
  static nextEvents(state: MyEventsStateModel): ActiveEventDetailOutputDto[] {
    return state.nextEvents;
  }

  @Selector([MyEventsState])
  static pastEvents(state: MyEventsStateModel): ActiveEventDetailOutputDto[] {
    return state.pastEvents;
  }
  @Selector([MyEventsState])
  static countCancelEvents(state: MyEventsStateModel): number {
    return state.cancelEvents.length;
  }

  @Selector([MyEventsState])
  static cancelEvents(state: MyEventsStateModel): ActiveEventDetailOutputDto[] {
    return state.cancelEvents;
  }
}
